import React from "react";
import { Elem, ElemBefore } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import {
	CommonPropertyProps,
	ElementLayout,
	ElementTypeList,
} from "schemas/elements";
import LastElement from "./LastElement";
import ProportionalWidth from "./ProportionalWidth";
import { ELEMENTS_MIN_MAX_WIDTH } from "./constants";
import { useSelector } from "react-redux";
import { getFormFullWidth } from "data/app/appSelectors";

const ElementSettings = ({
	id = uuidv4(),
	value,
	...rest
}: CommonPropertyProps & { fullWidth: boolean; elem: ElementTypeList }) => {
	const { t } = useTranslation();

	const props = { id, ...rest };

	const fullWidth = useSelector(getFormFullWidth);

	return fullWidth ? (
		<Elem className="elem-validation">
			<ElemBefore
				label={t(`formDesigner.properties.${rest.field}`)}
				required={false}
			/>
			<div className="elem-elements-settings">
				<div className="form-group form-details">
					<div className="row">
						{!ELEMENTS_MIN_MAX_WIDTH[rest.elem]
							?.hideProportional && (
							<div className="col">
								<ProportionalWidth
									value={value as ElementLayout}
									{...props}
								/>
							</div>
						)}
						<div className="col">
							<LastElement
								value={value as ElementLayout}
								{...props}
							/>
						</div>
					</div>
				</div>
			</div>
		</Elem>
	) : null;
};

export default ElementSettings;
